import {
  EMPTY_FUNCTION,
  EMPTY_FUNCTION_ASYNC,
} from '../../../../constants/common'
import { UserProfileContextProvider } from '../../../User'
import { UserProfilePageHeader } from '../../../UserProfilePage'
import { Container } from '../../Container'

import { PROFILE_HEADER_INHABITANT_VARIANTS } from './ProfileHeaderInhabitant.constants'

function ProfileHeaderInhabitant() {
  return PROFILE_HEADER_INHABITANT_VARIANTS.map(({ inhabitantData, label }) => (
    <Container key={label} label={label}>
      <UserProfileContextProvider
        isInitiated
        handleCloseModal={EMPTY_FUNCTION}
        handleEntityReload={EMPTY_FUNCTION_ASYNC}
        handleReloadTabs={EMPTY_FUNCTION_ASYNC}
        handleUpdateEntity={EMPTY_FUNCTION_ASYNC}
        isLoading={false}
        isPerformingAction={false}
        setModal={EMPTY_FUNCTION}
        setPerformingAction={EMPTY_FUNCTION}
        userData={inhabitantData}
      >
        <UserProfilePageHeader />
      </UserProfileContextProvider>
    </Container>
  ))
}

export default ProfileHeaderInhabitant
